export default "__VITE_ASSET__ByBxY7JU__"